import { memo } from 'react';
import { AlertCircle, CreditCard } from 'lucide-react';
import { useCreditsStore } from '../../store/creditsStore';
import { errorText } from '../../utils/errorText';

const NodeError = memo(({ error, insufficientCredits }) => {
  const openBuyModal = useCreditsStore(s => s.openBuyModal);

  if (!error) return null;

  return (
    <div className="node-error" data-testid="node-error">
      <div className="node-error-msg">
        <AlertCircle size={12} />
        <span>{errorText(error)}</span>
      </div>
      {insufficientCredits && (
        <button
          className="node-buy-credits-btn"
          onClick={(e) => {
            e.stopPropagation();
            openBuyModal();
          }}
          data-testid="node-buy-credits-btn"
        >
          <CreditCard size={12} />
          Comprar Créditos
        </button>
      )}
    </div>
  );
});

NodeError.displayName = 'NodeError';
export default NodeError;
